// extracted by mini-css-extract-plugin
export var deleteIcon = "_nz-5";
export var deleteOption = "_nz-3";
export var divider = "_nz-2";
export var downloadIcon = "_nz-4";
export var drawer = "_nz-0";
export var drawerFooter = "_nz-6";
export var drawerOpen = "_nz-1";
export var highlighted = "_nz-7";
export var lighterHighlight = "_nz-8";